import { CommonActions, NavigationProp, ParamListBase } from '@react-navigation/native';

/**
 * Removes the first screen of a tab from the navigation history.
 *
 * Opening a screen in place of the tab's first route leaves it mounted after you
 * leave the tab, and the tab can restore it from saved nested state. Reset to the
 * tab's real first screen and clear that saved state.
 */
export function removeFirstScreenFromTabHistory(navigation: NavigationProp<ParamListBase>) {
  const state = navigation.getState();
  const currentRouteName = state.routes[state.index]?.name;
  const initialRouteName = state.routeNames[0];

  if (!currentRouteName || !initialRouteName || state.index !== 0) {
    return;
  }

  if (currentRouteName === initialRouteName) {
    return;
  }

  navigation.reset({
    index: 0,
    routes: [{ name: initialRouteName }],
  });

  const tabs = navigation.getParent();
  const tabRoute = tabs?.getState().routes.find(route => route.state?.key === state.key);
  if (!tabs || !tabRoute) {
    return;
  }

  tabs.dispatch({
    ...CommonActions.setParams({ state: undefined }),
    source: tabRoute.key,
  });
}
